module.exports = __webpack_public_path__ + "img/avatar.c65e841a.png";